import React from 'react';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import { GoogleIcon } from '../icons';
import palette from '../styles/palette';

const useStyles = makeStyles(({ typography }) => {
  const { pxToRem } = typography;
  return {
    button: {
      color: palette.typography.black.inactive,
      fontSize: '0.875rem',
      textTransform: 'none',
      height: '2.5rem',
      padding: `${pxToRem(6)} ${pxToRem(15)}`,
      maxWidth: pxToRem(200),
    },
    icon: {
      width: '1.125rem',
      height: '1.125rem',
      margin: '0 0.5rem',
    },
    label: {
      fontWeight: 500,
    },
  };
});

const FirebaseLoginButton = ({ onClick }) => {
  const styles = useStyles();
  return (
    <Paper>
      <Button
        className={styles.button}
        onClick={onClick}
        startIcon={<GoogleIcon className={styles.icon} />}
        classes={{
          label: styles.label,
        }}
      >
        Sign in with Google
      </Button>
    </Paper>
  );
};

export default FirebaseLoginButton;
